const updateEquipmentServices = {
  toastr: 'Serviço atualizado',
  toastrError: 'Tipo de Serviço já cadastrado',
  toastrError1: 'Insira outro nome'
};

export default updateEquipmentServices;
